function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M68 15v-3.6c0-1.326-1.102-2.4-2.462-2.4H6.462C5.102 9 4 10.074 4 11.4v44.4c0 1.326 1.102 2.4 2.462 2.4H9.5M68 26v29.8c0 1.326-1.102 2.4-2.462 2.4H18",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.462 19.8c0 3.314-2.756 6-6.154 6-3.399 0-6.154-2.686-6.154-6 0-3.313 2.755-6 6.154-6 1.669 0 3.182.648 4.291 1.7M4 39l14.694-14.326a4.518 4.518 0 013.152-1.274c1.182 0 2.316.459 3.152 1.274l14.214 13.858",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 34l.84.84a2 2 0 002.524.25l.272-.18a2 2 0 012.523.25l2.427 2.426a2 2 0 002.828 0L29 35",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M68 52h-3M11 52H4",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 52l5.334-6.477a2 2 0 013.178.118L24 52m5.5 0H59",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M68 48.6L54.101 35.05a3.01 3.01 0 00-2.1-.849 3.01 3.01 0 00-2.102.849L38.954 45.72M63.615 63h-3.692M54.462 63H36",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "/img/picture.svg";
export { SvgPicture as ReactComponent };